/**
 * Simple phonetic English to Arabic transliteration
 * Handles common patterns for Egyptian Arabic
 */

// Character mappings (most common phonetic patterns)
const CHAR_MAP: Record<string, string> = {
  // Vowels
  'a': 'ا',
  'e': 'ي',
  'i': 'ي',
  'o': 'و',
  'u': 'و',

  // Consonants
  'b': 'ب',
  'c': 'ك',
  'd': 'د',
  'f': 'ف',
  'g': 'ج',
  'h': 'ه',
  'j': 'ج',
  'k': 'ك',
  'l': 'ل',
  'm': 'م',
  'n': 'ن',
  'p': 'ب',
  'q': 'ك',
  'r': 'ر',
  's': 'س',
  't': 'ت',
  'v': 'ف',
  'w': 'و',
  'x': 'كس',
  'y': 'ي',
  'z': 'ز',
}

// Multi-character patterns (check these first)
const PATTERN_MAP: Record<string, string> = {
  'sh': 'ش',
  'ch': 'تش',
  'th': 'ث',
  'gh': 'غ',
  'kh': 'خ',
  'ph': 'ف',
}

export function transliterateToArabic(text: string): string {
  if (!text || text.trim() === '') return ''

  let result = ''
  let i = 0
  const lowerText = text.toLowerCase()

  while (i < lowerText.length) {
    let matched = false

    // Check multi-character patterns first
    for (const [pattern, arabic] of Object.entries(PATTERN_MAP)) {
      if (lowerText.substring(i, i + pattern.length) === pattern) {
        result += arabic
        i += pattern.length
        matched = true
        break
      }
    }

    // If no pattern matched, check single character
    if (!matched) {
      const char = lowerText[i]
      result += CHAR_MAP[char] || char // Keep original if no mapping
      i++
    }
  }

  return result
}

/**
 * Example usage:
 * transliterateToArabic('brand') => 'براند'
 * transliterateToArabic('online') => 'ونلين'
 * transliterateToArabic('screenshot') => 'سكرينشوت'
 */
